var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.735 6l3.905 3.905c.479.479.481 1.252-.001 1.734-.48.48-1.256.48-1.734.001L6 7.735 2.095 11.64c-.479.479-1.252.481-1.734-.001-.48-.48-.48-1.256-.001-1.734L4.265 6 .36 2.095C-.12 1.616-.121.843.36.36c.48-.48 1.256-.48 1.734-.001L6 4.265 9.905.36c.479-.479 1.252-.481 1.734.001.48.48.48 1.256.001 1.734L7.735 6z",
    transform: "translate(-1162 -260) translate(234 222) translate(0 16) translate(928 22)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.4a4e90eebf7b59404a73b63407a67925.svg";
export { ForwardRef as ReactComponent };